import filters from './filters';

const importFilter = (Vue) => {
  Vue.filter('dateFormat', filters.dateFormat);
  Vue.filter('numberFormat', filters.numberFormat);
  Vue.filter('arrayToString', filters.arrayToString);
  Vue.filter('tScope', filters.tScope);
  Vue.filter('tAction', filters.tAction);
  Vue.filter('tMAttr', filters.tMAttr);
  Vue.filter('tDevType', filters.tDevType);
  Vue.filter('tStructureType', filters.tStructureType);
  Vue.filter('tDevCategory', filters.tDevCategory);
  Vue.filter('tField', filters.tField);
};

export default importFilter;
